<template>
  <section class="footer_99">
    <div class="divider_line"></div>
    <div class="explain relative">
      <div
        class="content_item bottom-[40px] left-1/2 z-50 min-w-[1000px] translate-x-[-50%] text-center mobile:hidden opacity-100"
      >
        <a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="https://www.meizu.com/legal"
          >法律声明</a
        ><a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="https://www.meizu.com/privacy-policy"
          >隐私政策</a
        ><a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="https://www3.res.meizu.com/static/cn/_partial/footer/images/icp2_fb8db74.jpg"
          >合字B2-20170010</a
        ><a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496009"
          >粤公网安备 44049102496009 号</a
        ><a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="https://www3.res.meizu.com/static/cn/_partial/footer/images/com_licence_b00fe42.jpg"
          >营业执照</a
        ><a
          target="_blank"
          class="mr-[15px] inline-block whitespace-nowrap text-[14px] font-[200] text-white"
          href="https://www.meizu.com/myvu"
          >©2023 珠海星纪魅族信息技术有限公司</a
        >
      </div>
    </div>
    45
  </section>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="less" scoped>
.footer_99 {
  height: 60px;

  background-color: #f7f8fa;
  position: relative;
  overflow: hidden;

  a {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    display: inline-block;
    text-align: center;

    &:hover {
      text-decoration-line: underline;
      color: #000000;
    }
  }
}

.relative {
  position: relative;
}

.divider_line {
  width: 60vw;
  height: 1px;
  margin: auto;
  background-color: rgba(189, 189, 189, 0.2);
}

.explain {
  height: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;

  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.5);

  top: 10px;

  .content_item {
    width: 1200px;
    align-items: center;
  }

  .opacity-100 {
    opacity: 1;
  }

  .min-w-\[1000px\] {
    min-width: 1000px;
  }

  .translate-x-\[-50\%\],
  .translate-y-\[-100\%\] {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y))
      rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
      scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .text-white {
    --tw-text-opacity: 1;
    // color: rgb(115, 120, 128 / var(--tw-text-opacity));
    color: #737880;
  }

  .fixed {
    position: fixed;
  }

  .text-center {
    text-align: center;
  }

  .translate-x-\[-50\%\] {
    --tw-translate-x: -50%;
  }

  .min-w-\[1000px\] {
    min-width: 1000px;
  }

  .z-50 {
    z-index: 50;
  }

  .left-1\/2 {
    left: 50%;
  }

  .mr-\[15px\] {
    margin-right: 15px;
  }
}
</style>
